export const AzureDetails = {
    BaseURL: "https://login.microsoftonline.com/",
    TenantId: "9ee0e6d7-1d0a-423f-8648-15144ef85081",
    ClientId: '0bf259f0-2b2f-44cf-b74c-586d432fa378',
    RedirectURL: "https://sugarcreek.tdgdm.com/",
    scopeUri: ['https://graph.microsoft.com/v1.0/me',['user.Read']]
  };


